import React from 'react'
import { Row, Col } from 'reactstrap'
import RedirectButton from 'components/atoms/redirect-button'
import PropTypes from 'prop-types'

const propTypes = {
  subBanners: PropTypes.array
}

const defaultProps = {
  subBanners: []
}

const CmsHomepageSectionSubBanners = ({ subBanners }) => (
  //sub banner: left for FS, right for Blog
  <Row>
    {
      subBanners.map((section, index) => (
        <Col
          key={ `sub-banner-${index}` }
          lg={ 6 }
        >
          <img
            src={ section.image_url }
            alt={ section.alt_text }
            width='100%'
          />
          <h4>{ section.header_text }</h4>
          <h5>{ section.caption_text }</h5>
          <RedirectButton
            text={ `Edit ${section.name}` }
            path={ `sections/${section.id}` }
            color='primary'
            className="float-right mt-1"
            size='sm'
          />
        </Col>
      ))
    }
  </Row>
)

CmsHomepageSectionSubBanners.propTypes    = propTypes
CmsHomepageSectionSubBanners.defaultProps = defaultProps

export default CmsHomepageSectionSubBanners
